import EddyEditTranscriptModal from './EddyEditTranscriptModal';
import EddyEditTranscriptModalContents from './EddyEditTranscriptModalContents';

export default EddyEditTranscriptModal;
export { EddyEditTranscriptModalContents };
